<!-- 活动管理子组件 -->
<template>
  <div class="active-manage">
    <div style="margin-top: -30px">
      <icon-title
        title="活动管理"
        :img-src="require('@/assets/home/admin/home/text_title.png')"
      />
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 左侧区域（可滚动） -->
      <div class="left-area">
        <!-- 搜索栏 -->
        <div class="search-bar">
          <div
            class="search-input"
            style="display: flex; justify-content: space-between"
          >
            <span>标题：</span>
            <div style="">
              <el-input
                v-model="searchQuery"
                placeholder="请输入"
                style="width: 200px"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                @click="handleClick('left', '搜索')"
                style="margin-left: 10px"
                >搜索</el-button
              >
            </div>
          </div>
          <div class="search-buttons">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              plain
              @click="handleClick('left', '新增')"
              >新增</el-button
            >
            <el-button
              type="warning"
              size="small"
              icon="el-icon-edit"
              plain
              @click="handleClick('left', '修改')"
              >修改</el-button
            >
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              @click="handleClick('left', '删除')"
              >删除</el-button
            >
          </div>
        </div>

        <!-- 活动列表 -->
        <div class="active-list">
          <el-empty
            v-if="activities.length === 0"
            :image-size="200"
            style="margin-top: 50px"
          ></el-empty>
          <div
            v-for="(activity, index) in activities"
            :key="activity.id"
            class="active-item"
            :style="{
              border:
                selectedActiveId == activity.activeId
                  ? '1px solid var(--primary)'
                  : '1px solid #e0e0e0',
            }"
            @click="selectActive(activity)"
          >
            <div
              class="select-dot"
              v-if="selectedActiveId == activity.activeId"
            >
              <i class="iconfont icon-duihao" style="color: #fff"> </i>
            </div>
            <div class="active-header">
              <icon-title
                :title="activity.activeName"
                :img-src="$utils.getFullImageUrl('0.png')"
                imgWidth="15px"
              />
              <!-- <el-checkbox
                v-model="activity.checked"
                style="margin-right: 10px"
              ></el-checkbox> -->
              <span
                class="status-tag"
                :class="[activity.status == 1 ? 'ongoing' : 'ended']"
                >{{ activity.status == 0 ? "已结束" : "进行中" }}</span
              >
            </div>
            <div class="active-info">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <p><span>发布人：</span>{{ activity.publisher }}</p>
                <p><span>限制人数：</span>{{ activity.limitPeople }}</p>
              </div>
              <p>
                <span>活动时间：</span>{{ activity.startTime }} -
                {{ activity.endTime }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧用户列表 -->
      <div class="user-list">
        <div class="user-list-header">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            plain
            @click="handleClick('right', '新增')"
            >新增</el-button
          >
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            @click="handleClick('right', '删除')"
            >删除</el-button
          >
        </div>
        <CustomTable
          :tableData="tableData"
          :tableHeaders="tableHeaders"
          :showSelection="true"
          :pagination="pagination"
          :loading="tableLoading"
          tableHeight="calc(100vh - 200px)"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <template #action="{ row }">
            <div class="action-buttons">
              <div
                v-for="button in actionButtons.tableArticleButtons"
                :key="button.id"
              >
                <el-button
                  v-if="button.id === 'deleteRow'"
                  class="custom-btn none"
                  size="small"
                  @click="handleClick('right', button, row)"
                  >{{ button.text }}</el-button
                >
              </div>
            </div>
          </template>
        </CustomTable>
      </div>
    </div>
    <!-- 左侧活动列表弹窗-->
    <!-- 引入编辑弹窗组件 -->
    <EditDialog
      ref="editDialog"
      :visible="dialogVisible"
      :title="`${title}活动`"
      :img-src="require('@/assets/home/admin/home/text_title.png')"
      :fields="formFields"
      :labelPosition="'top'"
      :form-rules="formRules"
      :initial-data="formData"
      :isShowList="['取消', '确认']"
      @update:visible="dialogVisible = $event"
      @confirm="handleConfirm"
      @close="dialogVisible = false"
      @upload-success="handleUploadSuccess"
    >
    </EditDialog>
    <!-- <CustomElDialog :visible.sync="showDialog" width="600px" height="auto">
      <template #content>
         <icon-title
        :title="`${title}活动`"
        :img-src="require('@/assets/home/admin/home/text_title.png')"
      />
      </template>
    </CustomElDialog> -->
  </div>
</template>
<script>
import { tableHeaders, actionButtons } from "@/utils/defaultData";
export default {
  name: "ActiveManageIndex",
  data() {
    return {
      selectedActiveId: "",
      title: "",
      dialogVisible: false,
      actionButtons: actionButtons,
      tableHeaders: tableHeaders.userTable,
      pagination: {
        total: 14,
        currentPage: 1,
        pageSize: 10,
      },
      formData: {
        // 活动名称
        activeName: "",
        // 发布人
        publisher: "",
        // 限制人数
        limitPeople: "",
        // 活动开始时间
        startTime: "",
        // 活动结束时间
        endTime: "",
        // 活动状态
        status: 0,
        // 上传图片
        coverImage: "",
      },
      formFields: [
        {
          label: "活动名称",
          prop: "activeName",
          type: "input",
          placeholder: "请输入活动名称",
        },
        {
          label: "限制人数",
          prop: "limitPeople",
          type: "input",
          placeholder: "请输入限制人数",
          // regex: /^[a-z]+$/,
          // regexMsg: "只能输入小写字母（a-z）",
          // filterInput: true,
        },
        {
          label: "开始日期",
          prop: "startTime",
          type: "date", // 新增的date类型
          required: false,
          placeholder: "请选择开始日期",
          fullWidth: false, // 两列布局
          dateType: "date", // 可选：date/datetime/daterange/month/year等
          format: "yyyy-MM-dd", // 显示格式
          valueFormat: "yyyy-MM-dd", // 绑定值格式
        },
        {
          label: "结束日期",
          prop: "endTime",
          type: "date", // 新增的date类型
          required: false,
          placeholder: "请选择结束日期",
          fullWidth: false, // 两列布局
          dateType: "date", // 可选：date/datetime/daterange/month/year等
          format: "yyyy-MM-dd", // 显示格式
          valueFormat: "yyyy-MM-dd", // 绑定值格式
        },
        {
          label: "联系电话",
          prop: "phone",
          type: "input",
          placeholder: "请输入联系电话",
          // regex: /^[a-z]+$/,
          // regexMsg: "只能输入小写字母（a-z）",
          // filterInput: true,
        },
        {
          label: "地址",
          prop: "address",
          type: "input",
          placeholder: "请输入地址",
        },
        {
          label: "活动描述",
          prop: "description",
          type: "textarea",
          placeholder: "请输入活动描述",
          fullWidth: true,
        },
        {
          label: "商品封面",
          prop: "coverImage",
          type: "upload", // 图片上传类型
          required: false,
          fullWidth: true, // 单独占一行
          uploadUrl: "/api/upload/image", // 上传接口地址
        },
      ],
      formRules: {
        activeName: [
          {
            required: true,
            message: "请输活动名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      tableLoading: false,
      searchQuery: "",
      activities: [],
      tableData: [],
      userPagination: {
        total: 7,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    console.log("打印userTableHeaders", tableHeaders);
    // 初始化时获取活动列表
    this.getActiveList();
    // 初始化时获取用户列表
    this.getUserList();
  },
  methods: {
    // 获取用户列表
    getUserList() {
      this.$api.admin.user.getUserListAPI().then((res) => {
        console.log("获取用户列表", res);
        if (res.code == 200) {
          this.tableData = res.data;
          console.log("获取用户列表", this.userTableData);
          // this.userPagination.total = res.data.total;
        }
      });
    },
    // 获取活动列表
    getActiveList() {
      this.$api.admin.active
        .getActiveListAPI({ activeName: this.searchQuery })
        .then((res) => {
          if (res.code == 200) {
            this.activities = res.data;
            if (res.data.length > 0) {
              this.selectedActiveId = res.data[0].activeId;
            }
            console.log("获取活动列表", this.activities);
            // this.userPagination.total = res.data.total;
          }
        });
    },
    // 左侧活动列表点击事件
    selectActive(item) {
      this.selectedActiveId = item.activeId;
    },
    // 处理确认事件
    handleConfirm(event) {
      console.log("编辑弹窗确认回调", event, this.title);
      if (this.title === "新增") {
        this.$api.admin.active.addActiveAPI(event).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "新增活动成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.getActiveList();
          }
        });
        return;
      }
      this.$api.admin.active.updateActiveAPI(event).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "修改活动成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.getActiveList();
        }
      });
      return;
    },
    // 上传成功回调函数
    handleUploadSuccess(res, file,fileList,prop) {
      console.log("上传成功回调", res, file,fileList,prop);
      // 处理上传成功后的逻辑，例如更新表单数据
      // this.formData.coverImage = data.url;
    },
    // 编辑弹窗取消回调
    // 处理每页显示条数变化
    handleSizeChange(newPagination) {
      console.log("每页条数变化", newPagination);
      this.pagination = newPagination;

      // this.getList();
    },
    // 处理页码变化
    handleCurrentChange(newPagination) {
      this.tableLoading = true;
      console.log("页码变化", newPagination);
      this.tableData = [
        {
          name: "最后加的",
          type: "男",
          image:
            "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
          uploadTime: "2025-09-11 10:00:00",
          uploadUser: "admin",
          status: false,
        },
      ];
      // this.pagination = newPagination;
      // this.getList();
    },
    // 处理选择事件
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log("父组件中选项变更了", this.selectedRows);
    },
    // 处理点击事件
    handleClick(area, type, row) {
      this.title = type;
      console.log("点击事件:", area, type, row);
      // 这里可以添加点击事件的逻辑
      if (area === "left") {
        if (type === "搜索") {
          // 搜索活动
          console.log("左侧搜索活动:", this.searchQuery);
          // 获取活动列表
          this.getActiveList();
          // 这里可以添加搜索活动的逻辑
        } else if (type === "新增") {
          // 新增活动
          console.log("左侧新增活动");
          this.dialogVisible = true;
          // 这里可以添加新增活动的逻辑
        } else if (type === "修改") {
          // 修改活动
          console.log("左侧修改活动:", row, this.selectedActiveId);
          this.formData = this.activities.find(
            (activity) => activity.activeId == this.selectedActiveId,
          );
          this.dialogVisible = true;
          // 这里可以添加修改活动的逻辑
        } else if (type === "删除") {
          // 删除活动
          console.log("左侧删除活动:", this.selectedActiveId);
          const activeName = this.activities.find(
            (activity) => activity.activeId == this.selectedActiveId,
          ).activeName;
          this.$modal
            .confirm('是否确认删除编号为"' + activeName + '"的数据项？')
            .then(() => {
              // this.getList();
              this.$api.admin.active
                .deleteActiveAPI({ activeId: this.selectedActiveId })
                .then((res) => {
                  console.log("删除活动", res);
                  if (res.code == 200) {
                    this.$modal.msgSuccess("删除成功");
                    this.dialogVisible = false;
                    this.getActiveList();
                  }
                });
            })
            .catch(() => {
              this.$modal.msgError("删除失败");
            });
        }
      } else if (area === "right") {
        if (type === "新增") {
          // 新增用户
          console.log("右侧新增用户");
          // 这里可以添加新增用户的逻辑
        } else if (type === "删除") {
          // 删除用户
          console.log("右侧删除用户:", row);
          // 这里可以添加删除用户的逻辑
        }
      }
    },

    // // 新增活动
    // handleAdd() {
    //   console.log("新增活动");
    //   // 这里可以添加新增活动的逻辑
    // },

    // // 修改活动
    // handleEdit() {
    //   const selectedActivities = this.activities.filter(
    //     (activity) => activity.checked,
    //   );
    //   console.log("修改活动:", selectedActivities);
    //   // 这里可以添加修改活动的逻辑
    // },

    // // 删除活动
    // handleDelete() {
    //   const selectedActivities = this.activities.filter(
    //     (activity) => activity.checked,
    //   );
    //   console.log("删除活动:", selectedActivities);
    //   // 这里可以添加删除活动的逻辑
    // },

    // // 新增用户
    // handleUserAdd() {
    //   console.log("新增用户");
    //   // 这里可以添加新增用户的逻辑
    // },

    // // 修改用户
    // handleUserEdit() {
    //   console.log("修改用户");
    //   // 这里可以添加修改用户的逻辑
    // },

    // // 删除用户
    // handleUserDelete() {
    //   console.log("删除用户");
    //   // 这里可以添加删除用户的逻辑
    // },

    // // 删除单个用户
    // handleUserDeleteItem(row) {
    //   console.log("删除用户:", row);
    //   // 这里可以添加删除单个用户的逻辑
    // },

    // // 用户分页变化
    // handleUserPageChange(page) {
    //   this.userPagination.currentPage = page;
    //   console.log("分页变化:", page);
    //   // 这里可以添加分页查询逻辑
    // },
  },
};
</script>
<style scoped lang="scss">
.active-manage {
  height: calc(100vh - 48px);
  overflow: hidden;
}

/* 主内容区域 */
.main-content {
  display: flex;
  gap: 10px;
  height: 100%;
  /* 左侧区域 */
  .left-area {
    width: 350px;
    height: 100%;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    /* 搜索栏 */
    .search-bar {
      padding: 10px;
      border-bottom: 1px solid #e0e0e0;
      .search-input {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        span {
          margin-right: 10px;
        }

        el-input {
          margin-right: 10px;
        }
      }

      .search-buttons {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    }

    /* 活动列表 */
    .active-list {
      flex: 1;
      overflow-y: auto;
      padding: 10px;

      .active-item {
        cursor: pointer;
        padding: 15px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        margin-bottom: 10px;
        position: relative;
        .active-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: space-between;

          h3 {
            flex: 1;
            font-size: 14px;
            font-weight: bold;
            margin: 0;
          }

          .status-tag {
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 5px;

            &.ongoing {
              border: 1px solid #c2f4e2;
              background-color: #e6f7f1;
              color: #0eb275;
            }

            &.ended {
              border: 1px solid #f4c4c4;
              background-color: #fff3f3;
              color: #f65a5a;
            }
          }
        }

        .active-info {
          font-size: 12px;
          color: #666;

          p {
            margin: 5px 0;

            span {
              color: #999;
            }
          }
        }
      }
    }
  }

  /* 右侧用户列表 */
  .user-list {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;

    .user-list-header {
      display: flex;
      justify-content: flex-end;
      display: flex;
      gap: 10px;
      padding: 10px 10px 10px 0;
    }

    el-table {
      flex: 1;
      min-height: 0;
    }

    .pagination {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
